export default "__VITE_ASSET__D9G6xL4u__"